export const getAmplitudeTrackingUrl = () => {
  const url = window.location.origin;

  return `${url.replace('app', 'trace')}/2/httpapi`;
};
